export const COOPERATION_AGREEMENT_EN_NAME = "Daytrip cooperation agreement";
export const SELFIE_VIDEO_EN_NAME = "Selfie video";
